import React from 'react';
import GoogleOneTap from '../../../components/GoogleOneTap';
import { useAppSelector } from '../../../stores/redux.store';
import { loginPageId } from '../constants';
import { useLoginRecoveryOptionsContext } from '../contexts/LoginRecoveryOptionsContext';
import { useSocialLogin } from '../hooks/useSocialLogin';
import { useDynamicConfigs } from '../../../utilities/feature-flags/dynamic-config';
import { AidFrontendDynamicConfig } from '../../../providers/DynamicConfigs';
import { getBooleanDynamicConfigValueOrDefault } from '../../../providers/common';

export const LoginGoogleOneTapRenderBoundary = ({ children }: { children: React.ReactNode }) => {
  const dynamicConfigs = useDynamicConfigs();

  const { loginRecoveryOptions } = useLoginRecoveryOptionsContext();

  const { isGoogleOneTapDismissed } = useSocialLogin();

  const { googleAuthClientId } = useAppSelector(state => state.appConfig);
  const hashedCsrfToken = useAppSelector(state => state.hashedCsrfToken);

  const disableOneTap =
    isGoogleOneTapDismissed ||
    getBooleanDynamicConfigValueOrDefault(
      dynamicConfigs,
      AidFrontendDynamicConfig.GOOGLE_ONE_TAP_KILL_SWITCH
    );

  return (
    <GoogleOneTap
      csrfToken={hashedCsrfToken ?? 'token-should-be-loaded'}
      googleAuthClientId={googleAuthClientId}
      source={loginPageId}
      enabled={!disableOneTap}
      recoveryOptions={loginRecoveryOptions}>
      {children}
    </GoogleOneTap>
  );
};
